export default __webpack_public_path__ + "static/media/linkedin.2a22e52b.png";